module.exports = __webpack_public_path__ + "static/media/client-logo-32.2641c2d0.jpg";